import * as React from "react";
import { Text, View, TouchableOpacity, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { currentLanguage } from "../../translations/CurrentLanguage";

import NumberKeyComponent from "./NumberKeyComponent";
import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, formatMoney, radius } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

export default class NumberKeysComponent extends React.PureComponent {
  onPay = () => this.props.onPay();

  keys() {
    const wallet = this.props.paymentType === "Wallet";
    const rows = [
      ["1000", "7", "8", "9"],
      ["500", "4", "5", "6"],
      ["200", "1", "2", "3"],
      ["100", wallet ? "00" : ".", "0", "Del"],
    ];
    // a wallet payment asks for a pin, amounts make no sense there
    return wallet ? rows.map(row => row.slice(1)) : rows;
  }

  renderWallet() {
    const { scanned_nfc } = this.props;
    const waiting =
      !("customer" in scanned_nfc) || !("attendant" in scanned_nfc);
    return (
      <Text style={styles.wallet}>
        {waiting
          ? "Waiting for nfc card..."
          : "Please use this keypad to enter customers pin"}
      </Text>
    );
  }

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);
    const { value, currency, isCurrencyDisabled } = this.props;
    const display = value
      ? isCurrencyDisabled
        ? value
        : formatMoney(0, currency).replace(/[\d.,\s]/g, "") + value
      : "";

    return (
      <View style={styles.container}>
        <View style={styles.display}>
          <Text style={styles.displayLabel}>{strings.AmountPaid}</Text>
          <Text
            numberOfLines={1}
            style={[styles.displayValue, display ? null : styles.placeholder]}
          >
            {display ? display : formatMoney(0, currency, isCurrencyDisabled)}
          </Text>
        </View>

        {this.keys().map((row, index) => (
          <View key={index} style={styles.row}>
            {row.map(text => (
              <NumberKeyComponent
                key={text}
                text={text}
                onChangeNumberKeyClick={this.props.onChangeNumberKeyClick}
              />
            ))}
          </View>
        ))}

        {this.props.mop === "Wallet" ? (
          this.renderWallet()
        ) : (
          <TouchableOpacity
            activeOpacity={0.85}
            disabled={!value}
            onPress={this.onPay}
            style={[styles.pay, value ? null : styles.payDisabled]}
          >
            <Icon name="check-circle" color="white" size={20} />
            <Text style={styles.payText}>{strings.Pay}</Text>
          </TouchableOpacity>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    maxWidth: 420,
    alignSelf: "center",
  },
  display: {
    marginHorizontal: 5,
    marginBottom: 10,
    paddingVertical: 12,
    paddingHorizontal: 18,
    borderRadius: radius.medium,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
  },
  displayLabel: {
    fontSize: 12,
    fontWeight: "600",
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: colors.textMuted,
  },
  displayValue: {
    marginTop: 2,
    fontSize: 30,
    fontWeight: "700",
    textAlign: "right",
    color: colors.text,
  },
  placeholder: {
    color: colors.textFaint,
  },
  row: {
    flexDirection: "row",
  },
  pay: {
    height: 58,
    marginTop: 12,
    marginHorizontal: 5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: radius.medium,
    backgroundColor: colors.primary,
  },
  payDisabled: {
    backgroundColor: "#cbd5e1",
  },
  payText: {
    marginLeft: 10,
    fontSize: 18,
    fontWeight: "700",
    color: "#fff",
  },
  wallet: {
    marginTop: 16,
    fontSize: 15,
    fontWeight: "600",
    textAlign: "center",
    color: colors.text,
  },
});
